import { z } from 'zod';
import { ADJUSTMENT_NOTE_MAX_LENGTH, ONE_TIME_BONUS_MAX_PERCENT, } from './payroll.js';
import { PNL_UNIT_NONE } from './pnl.js';
/** How a cancellation reason is labelled everywhere (settings, Excel, PDF) —
 *  cancellations recorded without a reason all share one label. */
export const NO_CANCEL_REASON_LABEL = 'ללא סיבה';
export const cancelReasonLabel = (name) => name?.trim() || NO_CANCEL_REASON_LABEL;
/** The class name as shown in the drawer / Excel / PDF. A co-taught meeting says
 *  so in-row, because its ₪ is this coach's share and not the meeting's full
 *  cost — without the note the amount looks wrong against the box's rate card. */
export function meetingClassLabel(m) {
    const name = m.class_name?.trim() || '—';
    return m.co_staff_name?.trim() ? `${name} (משותף עם ${m.co_staff_name.trim()})` : name;
}
// PUT body for editing a staff member's one-time bonus — or deduction — for a
// period. The two are the same shape and the same rules, so they share one
// schema; the endpoint decides which column the values land in.
const ISO_DATE = z.string().regex(/^\d{4}-\d{2}-\d{2}$/);
export const OneTimeBonusUpdateSchema = z.object({
    arbox_users_boxes_id: z.number().int(),
    period_start: ISO_DATE,
    period_end: ISO_DATE,
    /** The P&L unit the bonus belongs to — the bonus is per (coach, unit), so each
     *  branch's bonus lands in its own P&L and its own line to the coach. Absent ⇒
     *  PNL_UNIT_NONE (0), which is every line in a box that doesn't split by unit. */
    pnl_unit_id: z.number().int().nonnegative().default(PNL_UNIT_NONE),
    /** The ₪ amount. Kept even when mode is 'percent', so toggling the mode in the
     *  UI doesn't discard what was typed in the other one. */
    amount: z.number().nonnegative(),
    /** Absent ⇒ 'amount' — a client that predates the percentage option still
     *  sends a plain amount and keeps working. */
    mode: z.enum(['amount', 'percent']).default('amount'),
    percent: z.number().min(0).max(ONE_TIME_BONUS_MAX_PERCENT).default(0),
    /** Why: free text the coach sees next to the amount on their payslip. Absent
     *  ⇒ unchanged is NOT the rule — absent means "no reason", so a client that
     *  predates the field clears it rather than silently keeping a stale one. */
    note: z.string().max(ADJUSTMENT_NOTE_MAX_LENGTH).nullable().default(null),
});
/** The deduction's PUT body — identical to the bonus's, deliberately. */
export const DeductionUpdateSchema = OneTimeBonusUpdateSchema;
/** Longest private operator note on a payroll line — a few sentences, not a
 *  document. */
export const INTERNAL_NOTE_MAX_LENGTH = 1000;
/** PUT body for a line's internal note. The note is operator-only: it never
 *  reaches the coach (no payslip, email, PDF, Excel or approval page), so it
 *  lives outside the report rows and has its own endpoint. null / blank clears. */
export const InternalNoteUpdateSchema = z.object({
    arbox_users_boxes_id: z.number().int(),
    period_start: ISO_DATE,
    period_end: ISO_DATE,
    pnl_unit_id: z.number().int().nonnegative().default(PNL_UNIT_NONE),
    note: z.string().max(INTERNAL_NOTE_MAX_LENGTH).nullable().default(null),
});
//# sourceMappingURL=payroll-report.js.map